import "./Home.css";

function Home() {
  return (
    <div className="home-container">
      <h1 className="home-title">HR Management System</h1>

      <p className="home-description">
        The HR Management System is a full-stack web application designed to
        manage employee records efficiently. It allows HR teams to add new
        employees, view employee details, and update salaries seamlessly.
        This project is built using React for the frontend and Spring Boot
        for the backend following real-world industry practices.
      </p>
    </div>
  );
}

export default Home;